import * as api from "services/api";

import history from "../../../../history";

export const GET_INN = "[INN DETAIL] GET_INN";
export const GET_INN_SUCCESS = "[INN DETAIL] GET_INN_SUCCESS";
export const GET_INN_FAILED = "[INN DETAIL] GET_INN_FAILED";

export const GET_PRODUCT = "[INN DETAIL] GET_PRODUCT";
export const GET_PRODUCT_SUCCESS = "[INN DETAIL] GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_FAILED = "[INN DETAIL] GET_PRODUCT_FAILED";

export const CHANGE_PRODUCT_ITEM_STATUS =
	"[INN DETAIL] CHANGE_PRODUCT_ITEM_STATUS";
export const CHANGE_PRODUCT_ITEM_STATUS_SUCCESS =
	"[INN DETAIL] CHANGE_PRODUCT_ITEM_STATUS_SUCCESS";
export const CHANGE_PRODUCT_ITEM_STATUS_FAILED =
	"[INN DETAIL] CHANGE_PRODUCT_ITEM_STATUS_FAILED";

export const CANCEL_INN = "[INN DETAIL] CANCEL_INN";
export const CANCEL_INN_SUCCESS = "[INN DETAIL] CANCEL_INN_SUCCESS";
export const CANCEL_INN_FAILED = "[INN DETAIL] CANCEL_INN_FAILED";

export const ADD_PRODUCT = "[INN DETAIL] ADD_PRODUCT";
export const ADD_PRODUCT_SUCCESS = "[INN DETAIL] ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAILED = "[INN DETAIL] ADD_PRODUCT_FAILED";

export const ADD_PRODUCT_ITEM = "[INN DETAIL] ADD_PRODUCT_ITEM";
export const ADD_PRODUCT_ITEM_SUCCESS = "[INN DETAIL] ADD_PRODUCT_ITEM_SUCCESS";
export const ADD_PRODUCT_ITEM_FAILED = "[INN DETAIL] ADD_PRODUCT_ITEM_FAILED";

export const SCAN_PRODUCT_ITEM = "[INN DETAIL] SCAN_PRODUCT_ITEM";
export const SCAN_PRODUCT_ITEM_SUCCESS = "[INN DETAIL] SCAN_PRODUCT_ITEM_SUCCESS";
export const SCAN_PRODUCT_ITEM_FAILED = "[INN DETAIL] SCAN_PRODUCT_ITEM_FAILED";

export const REMOVE_PRODUCT_ITEM = "[INN DETAIL] REMOVE_PRODUCT_ITEM";
export const REMOVE_PRODUCT_ITEM_SUCCESS =
	"[INN DETAIL] REMOVE_PRODUCT_ITEM_SUCCESS";
export const REMOVE_PRODUCT_ITEM_FAILED =
	"[INN DETAIL] REMOVE_PRODUCT_ITEM_FAILED";

export const CHANGE_PRODUCT_ITEM = "[INN DETAIL] CHANGE_PRODUCT_ITEM";
export const CHANGE_PRODUCT_ITEM_SUCCESS =
	"[INN DETAIL] CHANGE_PRODUCT_ITEM_SUCCESS";
export const CHANGE_PRODUCT_ITEM_FAILED =
	"[INN DETAIL] CHANGE_PRODUCT_ITEM_FAILED";

export const EDIT_PRODUCT = "[INN DETAIL] EDIT_PRODUCT";
export const EDIT_PRODUCT_SUCCESS = "[INN DETAIL] EDIT_PRODUCT_SUCCESS";
export const EDIT_PRODUCT_FAILED = "[INN DETAIL] EDIT_PRODUCT_FAILED";

export const EDIT_PRODUCT_ITEM = "[INN DETAIL] EDIT_PRODUCT_ITEM";
export const EDIT_PRODUCT_ITEM_SUCCESS =
	"[INN DETAIL] EDIT_PRODUCT_ITEM_SUCCESS";
export const EDIT_PRODUCT_ITEM_FAILED = "[INN DETAIL] EDIT_PRODUCT_ITEM_FAILED";

export const DELETE_PRODUCT = "[INN DETAIL] DELETE_PRODUCT";
export const DELETE_PRODUCT_SUCCESS = "[INN DETAIL] DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILED = "[INN DETAIL] DELETE_PRODUCT_FAILED";

export const DONE_INN = "[INN DETAIL] DONE_INN";
export const DONE_INN_SUCCESS = "[INN DETAIL] DONE_INN_SUCCESS";
export const DONE_INN_FAILED = "[INN DETAIL] DONE_INN_FAILED";

export const SET_VALUE = "[INN DETAIL] SET_VALUE";
export const CLEAR_VALUE = "[INN DETAIL] CLEAR_VALUE";

export function setValue(payload) {
	return {
		type: SET_VALUE,
		payload
	};
}

export function clearValue() {
	return {
		type: CLEAR_VALUE
	};
}

export function getInn(id, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_INN
		});

		const { token } = getState().login;

		let response = await api.sendGet("/inn/" + id, {
			Authorization: "Bearer " + token
		});

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: GET_INN_SUCCESS,
				payload: json.model
			});

			callback && callback(null, json.model);
		} else {
			dispatch({ type: GET_INN_FAILED });
		}
	};
}

export function cancelInn(reason, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: CANCEL_INN
		});

		const { login, innDetail } = getState();

		let response = await api.sendPut(
			"/inn/" + innDetail.item.id + "/Cancel?reason=" + reason,
			null,
			{
				Authorization: "Bearer " + login.token
			}
		);

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: CANCEL_INN_SUCCESS,
				payload: json.model
			});

			history.push("/inns");
		} else {
			dispatch({ type: CANCEL_INN_FAILED });
			callback(
				"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
			);
		}
	};
}

export function reload() {
	return (dispatch, getState) => {
		const { innDetail } = getState();
		return dispatch(getInn(innDetail.item.id));
	};
}

export function doneInn(callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: DONE_INN
		});

		const { login, innDetail } = getState();

		let response = await api.sendPut(
			"/inn/" + innDetail.item.id + "/Finished",
			null,
			{
				Authorization: "Bearer " + login.token
			}
		);

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: DONE_INN_SUCCESS,
				payload: json.model
			});

			callback();
		} else {
			dispatch({ type: DONE_INN_FAILED });
			callback(
				"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
			);
		}
	};
}

export function searchProduct(code, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_PRODUCT
		});

		const { login } = getState();

		let response = await api.sendGet("/product/code/" + code, {
			Authorization: "Bearer " + login.token
		});

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: GET_PRODUCT_SUCCESS,
				payload: json.model
			});

			callback(null, json.model);
		} else {
			dispatch({ type: GET_PRODUCT_FAILED });
			callback(
				"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
			);
		}
	};
}

export function addProduct(model, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: ADD_PRODUCT
		});

		const { login, innDetail } = getState();

		let response = await api.sendPost(
			"/inn/" + innDetail.item.id + "/Add",
			model,
			{
				Authorization: "Bearer " + login.token
			}
		);

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: ADD_PRODUCT_SUCCESS,
				payload: json.model
			});

			callback();
		} else {
			try {
				var json = await response.json();

				if (json.errors) {
					dispatch({ type: ADD_PRODUCT_FAILED });
					callback(json.errors.join());
				} else {
					dispatch({ type: ADD_PRODUCT_FAILED });
					callback(
						"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
					);
				}
			} catch (error) {
				dispatch({ type: ADD_PRODUCT_FAILED });
				callback(
					"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
				);
			}
		}
	};
}

export function scanProductItems({ items }, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: SCAN_PRODUCT_ITEM
		});

		const { login, innDetail } = getState();

		let response = await api.sendPut(
			"/inn/" + innDetail.item.id + "/Devolution/Items",
			items,
			{
				Authorization: "Bearer " + login.token
			}
		);

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: SCAN_PRODUCT_ITEM_SUCCESS,
				payload: json.model
			});

			callback();
		} else {
			dispatch({ type: SCAN_PRODUCT_ITEM_FAILED });
			callback(
				"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
			);
		}
	};
}

export function addProductItems({ items, product }, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: ADD_PRODUCT_ITEM
		});

		console.log(items);
		const { login, innDetail } = getState();

		let response = await api.sendPost(
			"/inn/" + innDetail.item.id + "/Product/" + product.productId + "/Items",
			items,
			{
				Authorization: "Bearer " + login.token
			}
		);

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: ADD_PRODUCT_ITEM_SUCCESS,
				payload: json.model
			});

			callback();
		} else {
			dispatch({ type: ADD_PRODUCT_ITEM_FAILED });
			callback(
				"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
			);
		}
	};
}

export function removeItem(item, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: REMOVE_PRODUCT_ITEM
		});

		const { login, innDetail } = getState();

		let response = await api.sendDelete(
			"/inn/" + innDetail.item.id + "/Item/" + item.id,
			{
				Authorization: "Bearer " + login.token
			}
		);

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: REMOVE_PRODUCT_ITEM_SUCCESS,
				payload: json.model
			});

			callback();
		} else {
			dispatch({ type: REMOVE_PRODUCT_ITEM_FAILED });
			callback(
				"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
			);
		}
	};
}

export function changeItem(item, newItem, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: CHANGE_PRODUCT_ITEM
		});

		const { login, innDetail } = getState();

		let response = await api.sendPut(
			"/inn/" +
				innDetail.item.id +
				"/item/" +
				item.id +
				"/change/" +
				newItem.id,
			null,
			{
				Authorization: "Bearer " + login.token
			}
		);

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: CHANGE_PRODUCT_ITEM_SUCCESS,
				payload: json.model
			});

			for (const p of json.model.products) {
				for (const i of p.items) {
					if (i.productItemId === newItem.id) {
						callback(null, i);
					}
				}
			}
		} else {
			try {
				let json = await response.json();

				if (json.errors) {
					dispatch({ type: CHANGE_PRODUCT_ITEM_FAILED });
					callback(json.errors.join());
				} else {
					dispatch({ type: CHANGE_PRODUCT_ITEM_FAILED });
					callback(
						"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
					);
				}
			} catch (error) {
				dispatch({ type: CHANGE_PRODUCT_ITEM_FAILED });
				callback(
					"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
				);
			}
		}
	};
}

export function changeInnProductItemState(item, status, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: CHANGE_PRODUCT_ITEM_STATUS
		});

		const { login, innDetail } = getState();

		let response = await api.sendPut(
			"/inn/" + innDetail.item.id + "/item/" + item.id + "/Status/" + status,
			null,
			{
				Authorization: "Bearer " + login.token
			}
		);

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: CHANGE_PRODUCT_ITEM_STATUS_SUCCESS,
				payload: json.model
			});

			callback(null, json.model);
		} else {
			try {
				let json = await response.json();

				if (json.errors) {
					dispatch({ type: CHANGE_PRODUCT_ITEM_STATUS_FAILED });
					callback(json.errors.join());
				} else {
					dispatch({ type: CHANGE_PRODUCT_ITEM_STATUS_FAILED });
					callback(
						"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
					);
				}
			} catch (error) {
				dispatch({ type: CHANGE_PRODUCT_ITEM_STATUS_FAILED });
				callback(
					"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
				);
			}
		}
	};
}

export function editProduct(model, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: EDIT_PRODUCT
		});

		const { login, innDetail } = getState();

		let response = await api.sendPut(
			"/inn/" + innDetail.item.id + "/Edit",
			model,
			{
				Authorization: "Bearer " + login.token
			}
		);

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: EDIT_PRODUCT_SUCCESS,
				payload: json.model
			});

			callback();
		} else {
			try {
				let json = await response.json();

				if (json.errors) {
					dispatch({ type: EDIT_PRODUCT_FAILED });
					callback(json.errors.join());
				} else {
					dispatch({ type: EDIT_PRODUCT_FAILED });
					callback(
						"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
					);
				}
			} catch (error) {
				dispatch({ type: EDIT_PRODUCT_FAILED });
				callback(
					"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
				);
			}
		}
	};
}

export function editItem(item, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: EDIT_PRODUCT_ITEM
		});

		const { login, innDetail } = getState();

		let response = await api.sendPut(
			"/inn/" + innDetail.item.id + "/item/" + item.id,
			item,
			{
				Authorization: "Bearer " + login.token
			}
		);

		if (response.ok) {
			let json = await response.json();

			let payload = json.model;

			dispatch({
				type: EDIT_PRODUCT_ITEM_SUCCESS,
				payload
			});

			callback();
		} else {
			try {
				let json = await response.json();

				if (json.errors) {
					dispatch({ type: EDIT_PRODUCT_ITEM_FAILED });
					callback(json.errors.join());
				} else {
					dispatch({ type: EDIT_PRODUCT_ITEM_FAILED });
					callback(
						"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
					);
				}
			} catch (error) {
				dispatch({ type: EDIT_PRODUCT_ITEM_FAILED });
				callback(
					"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
				);
			}
		}
	};
}

export function deleteProduct(id, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: DELETE_PRODUCT
		});

		const { login, innDetail } = getState();

		let response = await api.sendDelete(
			"/inn/" + innDetail.item.id + "/" + id,
			{
				Authorization: "Bearer " + login.token
			}
		);

		if (response.ok) {
			let json = await response.json();

			dispatch({
				type: DELETE_PRODUCT_SUCCESS,
				payload: json.model
			});

			callback();
		} else {
			dispatch({ type: DELETE_PRODUCT_FAILED });
			callback(
				"Ocorreu um erro ao tentar enviar sua solicitação, tente novamente"
			);
		}
	};
}
